import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { recordingDashboardKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import {
  showRecordingDashboardContract,
  type ShowRecordingDashboardResponse
} from '@bliks-io/contracts';

export function useRecordingDashboard() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: recordingDashboardKeys.all,
    queryFn: async ({ signal }): Promise<ShowRecordingDashboardResponse> => {
      const { data } = await apiClient.get<ShowRecordingDashboardResponse>(
        showRecordingDashboardContract.path,
        { signal }
      );
      return data;
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000
  });
}
